import { render, staticRenderFns } from "./mortgage-marketvalue.vue?vue&type=template&id=4c16d894"
import script from "./mortgage-marketvalue.vue?vue&type=script&lang=ts"
export * from "./mortgage-marketvalue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports